import MainBtn from "../MainBtn/MainBtn.jsx";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "./driver.png";
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    backgroundColor: "#E5E5E5",
    display: "grid",
    gridTemplateColumns: "40% 60%",
    placeItems: "center",
  },
  containerMob: {
    gridArea: "Drive",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "#E5E5E5",
    placeItems: "center",
  },
  text: {
    margin: spacing(8),
    display: "flex",
    flexDirection: "column",
  },
  textMob: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    margin: `${spacing(2)}px 0`,
    width: "100%",
    color: "#1A3154",
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "63px",
    textTransform: "uppercase",
  },
  titleMob: {
    width: "80%",
    color: "#1A3154",
    fontWeight: 800,
    fontSize: "38px",
    marginBottom: "30px",
    textTransform: "uppercase",
  },
  paragraph: {
    margin: `${spacing(2)}px 0`,
    width: "100%",
    color: "#5E6162",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "29px",
    display: "flex",
    alignItems: "center",
  },
  paragraphMob: {
    width: "100%",
    color: "#5E6162",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "29px",
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
  },
}));

const Drive = () => {
  const mobile = useMediaQuery("(max-width:768px)");

  const classes = useStyles();

  const btnSettings = {
    variant: "contained",
    color: "primary",
    text: "Descarga la app",
  };

  return (
    <Box
      component="div"
      className={!mobile ? classes.container : classes.containerMob}
    >
      <CardMedia component="img" image={photo} className={classes.img} />
      <Box component="div" className={classes.text}>
        <Typography
          variant="h2"
          className={!mobile ? classes.title : classes.titleMob}
        >
          Sé uno de nuestros conductores
        </Typography>
        <Typography
          p="true"
          className={!mobile ? classes.paragraph : classes.paragraphMob}
        >
          Únete a nuestra red de asociados y genera viajes de una manera más
          práctica y segura.{" "}
        </Typography>
        <MainBtn btn={btnSettings} />
      </Box>
    </Box>
  );
};

export default Drive;
